import Api from './index'

export interface IInternetPackage {
    mobile_number?: string;
    operator_id?: number;
    package_type_id?: number | null;
    duration_id?: number | null;
    limit?: number | null;
    page?: number | null;
}

export const InterntPackageTypeApi = (data: IInternetPackage) => Api.POST({ url: "/v1/internet_package_list", data });

export interface IInternetBuy {
    package_id: number;
    package_title: string;
    amount: number;
    mobile_number: string;
    request_id?: string;
    type_operator_id: number;
    type_simcard_id: number;
    package_type_id: number;
    package_type_title: string;
    base_url: string;
}

export const InternetBuyApi = (data: IInternetBuy) => Api.POST({ url: "/v1/internet_buy", data })

export interface IInternetWalletBuy {
    user_pan: string;
    second_password: string;
    cvv2: number;
    expire_year: number;
    expire_month: number;
    additional_data?: string;
    package_id: number;
    package_title: string;
    amount: number;
    mobile_number: string;
    operator_type_id: number;
    simcard_type_id?: number;
    package_type_id: number;
    package_type_title: string;
}

export const InternetWalletBuyApi = (data: IInternetWalletBuy) => Api.POST({url: "/v1/buy_internet_package", data, hasErr: false})
